module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Hard-drive-2c8f321c7425d34d15bfad5e4c0ba5b3.svg";